import networks from "./networks";
import countries from "./countries";
import counties from "./counties";
import localities from "./localities";
import categories from "./categories";
import points from "./points";
import point_groups from "./point_groups";
import merchandisers from "./merchandisers";
import supervisors from "./supervisors";

export const RESOURCES = {
  networks,
  countries,
  counties,
  localities,
  categories,
  points,
  point_groups,
  merchandisers,
  supervisors,
};

export function getDescriptor(slug) {
  return RESOURCES[slug];
}
